<template>
  <div>
    <div class="card" style="min-height: 85vh">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Controls -->
          <div class="controls d-flex">
            <div class="input-group">
              <input
                type="text"
                id="search-competence"
                aria-label="SearchCompetence"
                aria-describedby="SearchCompetence"
                placeholder="Search competencies"
                class="form-control mr-2"
                @input="handleInput"
                v-model="keywords"
              />
            </div>
            <button
              type="button"
              class="ml-auto btn btn-success"
              data-toggle="modal"
              data-target="#exampleModal"
            >
              Add Competence
            </button>
          </div>
          <!-- Page Controls End -->
          <div class="table-container">
            <Spinner :isLoading="isLoading" />
            <CompetenceItem
              v-for="competence in competences"
              :key="competence.id"
              :competence="competence"
              v-on:newcomp="getCompetences(currentPage)"
            />
          </div>
        </div>
      </div>
      <span class="d-flex ml-auto bottom-controls">
        <div class="desktop-only" id="pagination">
          <Pagination
            v-show="!isLoading"
            :currentPage="currentPage"
            :totalPages="totalPages"
            @nextPage="nextPage"
            @prevPage="previousPage"
            @selectPageByNumber="setPageByNumber"
            @firstPage="setToFirstPage"
            @lastPage="setToLastPage"
            @keyup="keymonitor"
          ></Pagination>
        </div>
      </span>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Add Main Competence</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="d-flex align-items-center">
              <div class="form-group flex-grow-1">
                <input
                  v-model="mainCompetenceName"
                  type="text"
                  class="form-control"
                  name="competence"
                  placeholder="Competence name"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button
              type="button"
              @click="addMainCompetence(mainCompetenceName)"
              class="btn btn-primary"
            >
              Add
            </button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompetenceItem from './CompetenceItem.vue';
import axios from 'axios';
import Pagination from '../../Navigations/Pagination.vue';
import _ from 'lodash';
import titleMixin from '../../../mixins/titleMixin';
export default {
  components: {
    CompetenceItem,
    Pagination,
  },
  mixins: [titleMixin],
  title() {
    return 'Competencies | Jobshark';
  },
  data: () => ({
    isLoading: true,
    competences: [],
    keywords: '',
    mainCompetenceName: '',
    /* Pagination */
    currentPage: 1,
    totalPages: 1,
  }),
  methods: {
    setPageByNumber(pageNumber) {
      /*  console.log(pageNumber); */
      if (pageNumber > this.totalPages || pageNumber < 1) return;
      this.currentPage = Number(pageNumber);
      this.getCompetences(this.currentPage);
    },
    nextPage() {
      this.isLoading = true;
      if (this.currentPage >= 1) {
        this.currentPage++;
        this.getCompetences(this.currentPage);
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        --this.currentPage;
        this.getCompetences(this.currentPage);
      } else {
        this.currentPage = 1;
      }
    },
    setToFirstPage() {
      this.currentPage = 1;
      this.getCompetences(this.currentPage);
    },
    setToLastPage() {
      this.currentPage = this.totalPages;
      this.getCompetences(this.currentPage);
    },
    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight') {
        this.nextPage();
      }

      if (keyMessage == 'ArrowLeft') {
        this.previousPage();
      }
    },

    getCompetences(currentPage) {
      axios(`${process.env.VUE_APP_API_URL}/common/competence/all`, {
        method: 'post',
        data: {
          page: currentPage,
          count: 10,
          search_word: '',
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(response => {
        this.competences = response.data.data;
        this.totalPages = response.data.last_page;
        this.isLoading = false;
      });
    },

    handleInput: _.debounce(function(event) {
      this.isLoading = true;
      this.searchCompetence();
    }, 300), // 500ms debounce time

    searchCompetence() {
      axios(`${process.env.VUE_APP_API_URL}/common/competence/all`, {
        method: 'post',
        data: {
          page: 1,
          count: 10,
          search_word: this.keywords,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          this.currentPage = 1;
          this.competences = response.data.data;
          this.totalPages = response.data.last_page;
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
        });
    },
    addMainCompetence(name) {
      axios(`${process.env.VUE_APP_API_URL}/common/competence/create`, {
        method: 'post',
        data: {
          name: name,
          parent_id: null,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.$refs.close.click();
          this.getCompetences();
          this.$toasted.success('New main competence added successfully.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
          (this.mainCompetenceName = ''), this.getCompetences();
        })
        .catch(() => {
          this.$toasted.error('There was error while trying to add new competence.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    toggle(e) {
      e.target.classList.toggle('is-open');
    },
  },
  mounted() {
    this.getCompetences(this.currentPage);
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.controls {
  font-family: $font-family-sans-lato;
  padding: 1rem;

  .input-group {
    width: 35%;
    position: relative;

    i {
      color: #a7a7a7;
      position: absolute;
      pointer-events: none;
      top: 8px;
      right: 12px;
      font-size: 21px;
      z-index: 99;
    }

    .form-control {
      border-radius: 4px !important;
    }
  }

  .btn-outline-success {
    border-color: #ced4da;
  }
}

.modal-body {
  .form-control {
    padding: 6px 12px !important;
  }

  .btn-outline-success {
    height: 40px;
  }

  .custom-checkbox {
    margin: 20px 0 5px 0;
  }
}

.edit-modal {
  .modal-body {
    .text-center {
      margin-bottom: 20px;

      i {
        font-size: 51px;
        display: block;
        margin: 20px auto 30px auto;
      }

      .btn-success {
        font-size: 13px;
      }
    }

    .list-unstyled {
      li {
        margin-bottom: 6px;
        padding-bottom: 6px;
        border-bottom: 1px dashed #ddd;
        font-size: 14px;

        span {
          float: right;
        }
      }
    }
  }
}

.table-container {
  position: relative;
  padding: 1rem;

  .table {
    a {
      text-decoration: none;
    }

    thead {
      color: #222;
      font-size: 13px;
      font-weight: 700;
      text-transform: uppercase;

      th {
        vertical-align: middle;

        i {
          font-size: 31px;
          margin-right: 12px;
        }

        .fas {
          font-size: 14px;
          color: #666;
          transition: all 0.3s ease-in-out;
          -moz-transition: all 0.3s ease-in-out;
          -webkit-transition: all 0.3s ease-in-out;
        }

        &:last-of-type {
          a {
            margin-left: 12px;
            color: #666;

            i {
              font-size: 16px;
            }
          }
        }

        .is-open {
          .fas {
            -ms-transform: rotate(90deg);
            /* IE 9 */
            transform: rotate(90deg);
            /* Standard syntax */
          }
        }
      }
    }

    tbody {
      tr {
        th {
          font-weight: 400;
          font-size: 14px;

          i {
            font-size: 28px;
            margin-right: 18px;
          }
        }

        td {
          font-size: 14px;
          vertical-align: middle;
          font-family: $font-family-sans-lato;

          &:last-of-type {
            text-align: right;
            padding-right: 23px;

            a {
              color: #666;
              margin-left: 28px;

              i {
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }
}

.isDisabled {
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
}

.fa-exchange-alt {
  -ms-transform: rotate(90deg);
  /* IE 9 */
  transform: rotate(90deg);
  /* Standard syntax */
}
</style>
